import axios, { AxiosResponse } from 'axios';

import { ELeiStavZadosti } from 'enums/lei/leiStavZadosti';

export interface ILeiInfo {
    varsymbol: string;
    lei?: string;
    nazev?: string;
    stav?: ELeiStavZadosti | string;
    stavlei?: string;
    poslzmeny?: string;
    termincertifiakce?: string;
}

export interface ILeiPrehledUCtu {
    offset: number;
    limit: number;
    count: number;
    order: string;
    token: string;
    lei: ILeiInfo[];
}

const leiPrehledUctuApi = (filter?: string | number) => {
    return axios({
        method: 'GET',
        url: `LEI/Prehled${filter ? '?fulltext=' + filter : ''}`
    }).then((resp: AxiosResponse<ILeiPrehledUCtu>) => resp.data);
};

export default leiPrehledUctuApi;
